import { type JSX } from 'react';

import { Box, Typography } from '@mui/material';

type RowCountTextProps = {
    count: number;
    isFilterApplied: boolean;
    // The rows of `count` currently on screen, omitted while everything fits on one page.
    visibleRange?: { from: number; to: number };
};

const CAPTION_STYLES = { flex: 1, minWidth: 0, paddingLeft: '0.5rem', whiteSpace: 'nowrap' };

export function RowCountText({ count, isFilterApplied, visibleRange }: Readonly<RowCountTextProps>): JSX.Element {
    const noun = count === 1 ? 'row' : 'rows';
    /*
        The number comes first and stays unformatted inside #rows-count: ~30 Playwright locators
        read that element, two of them as `innerText.split(' ')[0]` cast to an int. The range is a
        sibling so it stays out of their way.
    */
    const label = isFilterApplied
        ? `${count} ${noun} ${count === 1 ? 'matches' : 'match'}`
        : `${count} ${noun}`;

    return (
        <Typography variant='body2' color='secondary.main' sx={CAPTION_STYLES}>
            {/* Only the count is a live region: the range changes on every page turn. */}
            <Box component='span' id='rows-count' role='status'>{label}</Box>
            {visibleRange && ` · showing ${visibleRange.from}–${visibleRange.to}`}
        </Typography>
    );
}
